import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {RepresentativeCommissionsPage} from "./-page/representative-commissions.page";
import {RepresentativeCommissionsPending} from "./-page/representative-commissions.pending";
import {representativeCommissionsSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/representatives/$representativeId/commissions/")({
  component: RouteComponent,
  pendingComponent: RepresentativeCommissionsPending,
  staticData: {meta: {labelDescriptor: routeMessages.commissions}},
  validateSearch: (search) => representativeCommissionsSearchSchema.parse(search),
});

function RouteComponent() {
  const {representativeId} = useParams({strict: false}) as {representativeId: string};
  const {includeDeleted} = Route.useSearch();

  return (
    <RepresentativeCommissionsPage
      includeDeleted={includeDeleted}
      representativeId={representativeId}
    />
  );
}
